import * as fetch from '../../../utils/action'
import obsDepartmentData from '../datas/obs-departament'
export default {
  getAnswerPageByQuery (ctx, data) {
    return fetch.getAnswerPageByQuery(data).then(res => {
      let result = obsDepartmentData.getAnswerPageByQuery(res)
      return result
    })
  },
  getQstionAnswerDetail (ctx, id) {
    return fetch.getQstionAnswerDetail(id).then(res => {
      let result = obsDepartmentData.getQstionAnswerDetail(res.data)
      return result
    })
  },
  answerTheAsk (ctx, data) {
    return fetch.answerTheAsk(data).then(res => {
      return res.data
    })
  },
  answerRecordsBlock (ctx, id) {
    return fetch.answerRecordsBlock(id).then(res => {
      return res.data
    })
  },
  answerRecordsDelete (ctx, id) {
    return fetch.answerRecordsDelete(id).then(res => {
      return res.data
    })
  },
  closeQuestion (ctx, id) {
    return fetch.closeQuestion(id).then(res => {
      return res.data
    })
  },
  deleteQuestion (ctx, id) {
    return fetch.deleteQuestion(id).then(res => {
      return res.data
    })
  }
}
